import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { z } from 'zod';
import { rotaDeTela } from '@/features/permissoes/guardas';
import { Registros } from '@/features/registros/componentes/Registros';
import { periodoPadrao } from '@/features/registros/formatos';

const id = z.uuid().optional().catch(undefined);
const dia = z.iso.date().optional().catch(undefined);
const busca = z.object({
  alunoId: id,
  fichaId: id,
  de: dia,
  ate: dia,
  cursor: z.string().optional().catch(undefined),
});

/** Treinos realizados (spec 011, CA-01 e CA-02). */
export const Route = createFileRoute('/_autenticado/registros/')({
  ...rotaDeTela('registros.lista'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const valores = Route.useSearch();
  const navigate = Route.useNavigate();
  // Sem período na URL: os últimos 30 dias (CA-02).
  const [padrao] = useState(() => periodoPadrao());
  const semPeriodo = valores.de === undefined && valores.ate === undefined;
  return (
    <Registros
      busca={semPeriodo ? { ...valores, ...padrao } : valores}
      aoMudarBusca={(novos) => {
        void navigate({ search: novos, replace: true });
      }}
      aoLimpar={() => {
        void navigate({ search: padrao, replace: true });
      }}
    />
  );
}
